import {useEffect, useRef, useState} from "react";
import {convertFromFinal, PipelineElement} from "../../pipeline-builder/PipelineConfig";
import {agent} from "../../../api/agent";
import {Skeleton} from "../../../api/types";
import {findElement} from "../../utils/PipelineHelper";
import styled from "styled-components";
import PipelineTree from "../../pipeline-builder/PipelineTree";
import LoadingContainer from "../../LoadingContainer";


interface Props {
    open: boolean;
    skeleton: Skeleton;
}

const LogsContainer = styled.div`
    overflow-y: scroll;
    width: 100%;
    transition: height 0.3s ease-in-out;
`;

export default function JobLogs({skeleton, open}: Props) {

    const [ci, setCi] = useState<PipelineElement | null>(null);
    const logsContainerRefs = useRef<HTMLDivElement>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        convertFromFinal(JSON.parse(skeleton.ci)).then(elements => {
            setCi(elements[0]);
            setLoading(false);
        });
    }, [skeleton.ci]);

    useEffect(() => {

        if (!open || loading) {
            return;
        }

        let buffer: any[] = [];
        const interval = setInterval(() => {
            let buffer2: any[] = [...buffer];
            buffer = buffer.slice(buffer2.length, buffer2.length);

            let logSkeleton: PipelineElement = ci!;
            for (const data of buffer2) {
                switch (data.type) {
                    case 'initial': {
                        if (data.from && data.from === 'skeleton') {
                            logSkeleton.id = data.id;
                            console.log('Skeleton initialized with id:', data.id);
                        }
                        let element = findElement(data.id, logSkeleton);
                        if (!element) {
                            console.error('Element not found for id:', data.id);
                            break;
                        }
                        element.lastStatus = data.status;
                        element.logs = data.logs;
                        break;
                    }
                    case 'status': {
                        let element = findElement(data.pipelineId, logSkeleton);
                        if (!element) {
                            console.error('Element not found for id:', data.pipelineId);
                            break;
                        }
                        element.lastStatus = data.status;
                        break;
                    }
                    case 'log': {
                        let element = findElement(data.pipelineId, logSkeleton);
                        if (!element) {
                            console.error('Element not found for id:', data.pipelineId);
                            break;
                        }
                        if (!element.logs) {
                            element.logs = [];
                        }
                        element.logs.push({
                            level: data.level,
                            message: data.message
                        });
                        break;
                    }
                }
            }
            if (buffer2.length > 0) {
                console.log('setCi with new data:', logSkeleton);
                setCi(JSON.parse(JSON.stringify(logSkeleton)));
            }
        }, 25);
        const callback = (data: any) => {
            buffer.push(data);
        }

        const id = agent.subscribe('/skeleton/logs/' + skeleton.id, callback);

        return () => {
            agent.unsubscribe(id);
            clearInterval(interval);
        };
    }, [open, loading]);

    return <LoadingContainer open={loading && open}>

        <LogsContainer style={{height: open ? '31rem' : '0'}}
                       className={'logsarea'}
                       ref={logsContainerRefs}>
            {ci && (
                <PipelineTree current={ci} active={null} isNotTest={true}
                              htmlElement={logsContainerRefs!.current}
                              isRunning={ci.lastStatus === 'running'}></PipelineTree>)}
        </LogsContainer>
    </LoadingContainer>;

}
